import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { AppConfig } from '../../../AppConfig';
import { CustomBaseEnityStyles } from '../../../styles/CustomStyles';
import { vsprintf } from 'sprintf-js';

export class AdvertiserInfo extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.pageKey = 'AdvertiserInfo'
    this.orgId = 'PRODUCT'
    this.advOrgId = this.props.match.params.id.split('-')[0]
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('campaignsSelfServe'), to: this.baseRoute() + '/ss-campaigns' },
      { title: 'Advertiser Info' },
    ]
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['users'], { orgId: this.advOrgId }) },
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', this.advOrgId], { }) },
    ]
    this.tableHeadersMap = {
      Info: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>Name: {Helper.formatName(current)}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Company Name: {this.org.title}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Tracking Code: {this.org.ac || 'none'}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>utm_source: {this.org.utm_source || 'none'}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Signed up: {Helper.formatTimestamp(this.org.createdTs)}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Email: {current.email}</span>
            <br/>
            <span className={css(Styles.spanValue, Styles.line2)}>Phone: {this.org.phones}</span>
            <br/>
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {}
    this.noTableHead = true
    this.noAdd = true
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onFetchSuccess(results) {
    this.org = results[1]
    this.pageTitle = `${this.org.title}`
    this.setState({
      items: results[0].items
    })
  }

  onActions(current) {
    const actions = []
    return actions
  }

}

const Styles = (AppConfig.CUSTOM_STYLE) ? CustomBaseEnityStyles : StyleSheet.create({
  spanValue: {
  },
  line2: {
    fontSize: 12
  },
})


// WEBPACK FOOTER //
// ./src/screens/admin/advertisers/AdvertiserInfo.js